import React, { ReactNode } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Editor from './Editor';

interface Props {
    children?: ReactNode;
    entity?: Record<string, unknown> & { editor?: (props: unknown) => JSX.Element };
    itemParam: string;
    route: string;
}
const ClientModal = ({ children, entity, itemParam, route }: Props) => {
    const params = useParams();
    const { push } = useHistory();

    const close = () => {
        push(route);
    }
    return entity ? <Editor route={route + '/' + params[itemParam]} entity={entity} itemId={params[itemParam]} editorClosed={close} >
        {children ? children : entity.editor?.({ route }) as any}
    </Editor> : null;
}


export default ClientModal;